module.exports = __webpack_public_path__ + "media/images/brand_logos/redcare-logo-sm-92a794785ce70e8d160182c5d348e3f0.png";